export const validation = {
  titleMaxChar: 50,
  paragraphMaxChar: 150,
  gallery: {
    min: 1,
    max: 6
  }
}